import { actions, types } from './requests'
export const GETCLIENTORDER_TYPES = {
    ...types('GETCLIENTORDER'),
}
export const GETCLIENTORDER_ACTIONS = {
    ...actions('GETCLIENTORDER'),
}
